/**
 * Created by piotr.pozniak@thebeaverhead.com on 24/11/2023.
 */

import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import * as organizationActions from "../../actions/organization";
import { activateTrial } from "../../actions/organizations";
import { updateOrgSetting } from "../../actions/organization";

export function useCurrentOrganizationStore() {
  const dispatch = useDispatch();
  const _currentOrganization = useSelector(
    (store) => store.currentOrganization
  );

  const editOrganization = useCallback(
    async (uuid, data, isAdminRequest) =>
      await dispatch(
        organizationActions.editOrganization(uuid, data, isAdminRequest)
      ),
    [dispatch]
  );

  const fetchBillingHistory = useCallback(
    async () => await dispatch(organizationActions.fetchBillingHistory()),
    [dispatch]
  );

  const editOrganizationSubscription = useCallback(
    async (uuid, expiry) =>
      await dispatch(
        organizationActions.editOrganizationSubscription(uuid, expiry)
      ),
    [dispatch]
  );
  const uploadBrandingFile = useCallback(
    async (type, file) =>
      await dispatch(organizationActions.uploadBrandingFile(type, file)),
    [dispatch]
  );

  const activateTrial = useCallback(
    async (payload) =>
      await dispatch(organizationActions.activateTrial(payload)),
    [dispatch]
  );
  const activateFreePlan = useCallback(
    async (payload) =>
      await dispatch(organizationActions.activateFreePlan(payload)),
    [dispatch]
  );

  const updateOrgSetting = useCallback(
    async (field, value) =>
      await dispatch(organizationActions.updateOrgSetting(field, value)),
    [dispatch]
  );

  const deleteOrganization = useCallback(
    async (uuid) =>
      await dispatch(organizationActions.deleteOrganization(uuid)),
    [dispatch]
  );

  const updateDomainSettings = useCallback(
    async (domainType, value) =>
      await dispatch(
        organizationActions.updateDomainSettings(domainType, value)
      ),
    [dispatch]
  );
  const refreshDnsStatus = useCallback(
    async () => await dispatch(organizationActions.refreshDnsStatus()),
    [dispatch]
  );
  const regenerateCertificate = useCallback(
    async () => await dispatch(organizationActions.regenerateCertificate()),
    [dispatch]
  );

  return {
    currentOrganization: _currentOrganization,
    editOrganization,
    fetchBillingHistory,
    editOrganizationSubscription,
    uploadBrandingFile,
    activateTrial,
    activateFreePlan,
    updateOrgSetting,
    deleteOrganization,
    updateDomainSettings,
    refreshDnsStatus,
    regenerateCertificate,
  };
}
